const Mock = require('mockjs');
// 获取 mock.Random 对象
const Random = Mock.Random;
// mock一组数据
const productData = function () {
    let Data = [];
    for (let i = 0; i < 8; i++) {
        let data = {
            a: Random.cname(), // Random.cname() 随机生成一个常见的中文姓名
            b: Random.date(),  // Random.date()指示生成的日期字符串的格式,默认为yyyy-MM-dd
            c: Random.city(),  // Random.city() 随机生成一个城市的名字
        }
        Data.push(data)
    }
    return {
        Data: Data
    }
}
const data = {
    datalist: [{ name: "第一", value: 0 }, { name: "第二", value: 1 },],
    mapDotList: [{ 'latitude': 109.219721, 'longitude': 18.800252, 'name': '乐东', 'value': 1, 'color': '#0394d9' },
    { 'latitude': 34.76, 'longitude': 113.65, 'name': '河南', 'value': 3, 'color': '#d94d02' },
    { 'latitude': 29.65, 'longitude': 91.13, 'name': '西藏', 'value': 4, 'color': '#b42fd5' },
    { 'latitude': 43.82, 'longitude': 87.62, 'name': '新疆', 'value': 5, 'color': '#0394d9' },],
    echartOption1: [
        {
            value: 'dxb',
            label: '东星斑',
            children: [{
                value: '1',
                label: '2-3cm'
            }, {
                value: '2',
                label: '5-6cm'
            }]
        },
        {
            value: 'lsb',
            label: '老鼠斑',
            children: [{
                value: '3',
                label: '大'
            }, {
                value: '4',
                label: '中'
            }, {
                value: '5',
                label: '小'
            }]
        }
    ]

}


// Mock.mock( url, post/get , 返回的数据)；
Mock.mock('/user/login', 'post', productData);
Mock.mock('/user/query', 'post', data);


// WEBPACK FOOTER //
// ./src/utils/mock.js